import { Nullable } from 'models/Nullable'
import { Avatar } from '@material-ui/core'
import { CameraAlt, CloudUpload, Delete } from '@material-ui/icons'
import { useSnackbar } from 'notistack'
import React from 'react'
import { MenuFab } from './MenuFab'

const scOptions = {
  cloudName: 'trygkalk-no',
  uploadPreset: 'ml_default',
  source: ['local'],
  multiple: false,
  tags: ['logos'],
  theme: 'minimal',
  language: 'nb',
  resourceType: 'image',
  maxImageFileSize: 1500000
}

type Props = {
  label: string
  value: string | null
  onChange: (value: Nullable<string>) => void
  children: React.ReactNode
}

export function ImageButton({ label, value, onChange, children }: Props) {
  const { enqueueSnackbar } = useSnackbar()
  const upload = () => {
    (window as unknown as any).cloudinary.openUploadWidget(scOptions, (error: any, response: any) => {
      if (error) {
        console.error(error)
        enqueueSnackbar('Noe gikk galt', { variant: 'error' })
        return
      }

      if (response.event === 'success') {
        onChange(response.info.secure_url as string)
      }
    })
  }

  return (
    <>
      <Avatar
        style={{ width: 120, height: 120, marginTop: -40 }}
        alt={label}
        src={value || undefined}
      >
        {children}
      </Avatar>
      <MenuFab
        size="small"
        color="primary"
        label="Endre bilde"
        icon={<CameraAlt />}
        FabStyle={{
          position: 'absolute',
          zIndex: 99,
          top: 50,
          marginRight: -60,
        }}
        options={[
          ['Slett bilde', <Delete />, () => onChange(null)],
          ['Last opp bilde', <CloudUpload />, () => upload()],
        ]}
      />
    </>
  )
}
